var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "requests pa-0", attrs: { fluid: "" } },
    [
      !_vm.retrievingHistoryRequests &&
      !_vm.historyRequestsFiltered &&
      !_vm.historyRequestCount
        ? _c(
            "v-row",
            { staticClass: "no-request", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { "align-self": "center", cols: "12", md: "10" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "mb-4", attrs: { justify: "center" } },
                    [
                      _c("v-img", {
                        attrs: {
                          contain: "",
                          "max-width": "120",
                          src: require("@/assets/images/no-content-penguin.svg")
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-4", attrs: { justify: "center" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("descriptions.noRequestHistory")) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _c("v-spacer")
            ],
            1
          )
        : _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("v-data-table", {
                directives: [
                  {
                    name: "resize",
                    rawName: "v-resize.quiet",
                    value: _vm.onWindowResized,
                    expression: "onWindowResized",
                    modifiers: { quiet: true }
                  }
                ],
                staticClass: "elevation-1 history-requests",
                attrs: {
                  dense: "",
                  expanded: _vm.expandedRows,
                  headers: _vm.historyRequestsHeaders,
                  "header-props": { sortIcon: "fa fa-arrow-up" },
                  "hide-default-footer": "",
                  items: _vm.$store.state.request.historyRequests.records,
                  "items-per-page": _vm.$store.state.request.pageSize,
                  loading: _vm.retrievingHistoryRequests,
                  "loading-text": _vm.$t("descriptions.loadingRequests"),
                  "mobile-breakpoint": "",
                  "must-sort": "",
                  "no-data-text": _vm.$t("descriptions.noRequestHistory"),
                  options: _vm.historyRequestsOptions,
                  page: _vm.historyRequestsCurrentPage,
                  "server-items-length":
                    _vm.$store.state.request.historyRequests.count,
                  "show-expand": "",
                  "single-select": true
                },
                on: {
                  "update:options": function($event) {
                    _vm.historyRequestsOptions = $event
                  },
                  "update:page": function($event) {
                    _vm.historyRequestsCurrentPage = $event
                  },
                  "click:row": _vm.onItemClicked
                },
                scopedSlots: _vm._u([
                  {
                    key: "header.createdBy",
                    fn: function() {
                      return [
                        _c("StaffSearch", {
                          attrs: {
                            "append-icon": _vm.historyRequestsOptions
                              .searchByName
                              ? ""
                              : "fal fa-search",
                            "target-class": "py-2 search-name",
                            clearable: !!_vm.historyRequestsOptions
                              .searchByName,
                            dense: "",
                            "hide-details": "",
                            solo: ""
                          },
                          model: {
                            value: _vm.historyRequestsOptions.searchByName,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.historyRequestsOptions,
                                "searchByName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "historyRequestsOptions.searchByName"
                          }
                        })
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "header.deptIds",
                    fn: function(ref) {
                      var header = ref.header
                      return [
                        _c("MultiSelectionList", {
                          attrs: { selection: _vm.departments },
                          on: {
                            selectionConfirmed: function($event) {
                              return _vm.onHistoryRequestFilterChanged(
                                header.value,
                                $event
                              )
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "ml-n4 subtitle-2 text-capitalize",
                                          attrs: {
                                            color: "secondary",
                                            text: ""
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$tc("labels.department", 1)
                                            ) +
                                            "\n              "
                                        ),
                                        _vm.historyRequestsOptions.filterBy
                                          .deptIds
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-2 mt-1",
                                                attrs: {
                                                  color: "grey",
                                                  right: "",
                                                  "x-small": ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                fas fa-filter\n              "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-2 mt-1",
                                                attrs: {
                                                  color: "grey",
                                                  right: "",
                                                  "x-small": ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                fal fa-filter\n              "
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ]
                    }
                  },
                  {
                    key: "header.inferredType",
                    fn: function(ref) {
                      var header = ref.header
                      return [
                        _c("MultiSelectionList", {
                          attrs: { selection: _vm.requestTypes },
                          on: {
                            selectionConfirmed: function($event) {
                              return _vm.onHistoryRequestFilterChanged(
                                header.value,
                                $event
                              )
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "ml-n4 subtitle-2 text-capitalize",
                                          attrs: {
                                            color: "secondary",
                                            text: ""
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("labels.type")) +
                                            "\n              "
                                        ),
                                        _vm.historyRequestsOptions.filterBy
                                          .inferredType
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-2 mt-1",
                                                attrs: {
                                                  color: "grey",
                                                  right: "",
                                                  "x-small": ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                fas fa-filter\n              "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-2 mt-1",
                                                attrs: {
                                                  color: "grey",
                                                  right: "",
                                                  "x-small": ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                fal fa-filter\n              "
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ]
                    }
                  },
                  {
                    key: "header.assocContentState",
                    fn: function(ref) {
                      var header = ref.header
                      return [
                        _c("MultiSelectionList", {
                          attrs: { selection: _vm.requestStatus },
                          on: {
                            selectionConfirmed: function($event) {
                              return _vm.onHistoryRequestFilterChanged(
                                header.value,
                                $event
                              )
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass:
                                            "ml-n4 subtitle-2 text-capitalize",
                                          attrs: {
                                            color: "secondary",
                                            text: ""
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("labels.status")) +
                                            "\n              "
                                        ),
                                        _vm.historyRequestsOptions.filterBy
                                          .assocContentState
                                          ? _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-2 mt-1",
                                                attrs: {
                                                  color: "grey",
                                                  right: "",
                                                  "x-small": ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                fas fa-filter\n              "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-2 mt-1",
                                                attrs: {
                                                  color: "grey",
                                                  right: "",
                                                  "x-small": ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                fal fa-filter\n              "
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ]
                    }
                  },
                  {
                    key: "item.createdBy",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.assocContent.contentType == "event"
                          ? _c(
                              "v-list-item",
                              { staticClass: "px-0" },
                              [
                                _c(
                                  "v-list-item-avatar",
                                  { staticClass: "mr-1" },
                                  [
                                    _c(
                                      "v-avatar",
                                      {
                                        attrs: {
                                          color:
                                            _vm.$store.state.org.employees[
                                              item.assocContent.assigneeId
                                            ].avatarBgColor,
                                          size: "30"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "white--text subtitle-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.getAvatar(
                                                    _vm.$store.state.org
                                                      .employees[
                                                      item.assocContent
                                                        .assigneeId
                                                    ]
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      {
                                        staticClass: "body-2 mb-1 name-n-avatar"
                                      },
                                      [
                                        _c("UserName", {
                                          attrs: {
                                            user:
                                              _vm.$store.state.org.employees[
                                                item.assocContent.assigneeId
                                              ]
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-subtitle",
                                      { staticClass: "caption mt-1" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.getJobInfo(item)) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : item.assocContent.contentType == "swap"
                          ? _c(
                              "v-list-item",
                              { staticClass: "px-0" },
                              [
                                _c(
                                  "v-list-item-avatar",
                                  { staticClass: "mr-1" },
                                  [
                                    _c(
                                      "v-avatar",
                                      {
                                        attrs: {
                                          color:
                                            _vm.$store.state.org.employees[
                                              item.assocContent.sourceUserId
                                            ].avatarBgColor,
                                          size: "30"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "white--text subtitle-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.getAvatar(
                                                    _vm.$store.state.org
                                                      .employees[
                                                      item.assocContent
                                                        .sourceUserId
                                                    ]
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      {
                                        staticClass: "body-2 mb-1 name-n-avatar"
                                      },
                                      [
                                        _c("UserName", {
                                          attrs: {
                                            user:
                                              _vm.$store.state.org.employees[
                                                item.assocContent.sourceUserId
                                              ]
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-subtitle",
                                      { staticClass: "caption mt-1" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.getJobInfo(item)) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : item.assocContent.contentType == "shiftrequest"
                          ? _c(
                              "v-list-item",
                              { staticClass: "px-0" },
                              [
                                _c(
                                  "v-list-item-avatar",
                                  { staticClass: "mr-1" },
                                  [
                                    _c(
                                      "v-avatar",
                                      {
                                        attrs: {
                                          color:
                                            _vm.$store.state.org.employees[
                                              item.assocContent.assigneeId
                                            ].avatarBgColor,
                                          size: "30"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "white--text subtitle-2"
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.getAvatar(
                                                    _vm.$store.state.org
                                                      .employees[
                                                      item.assocContent
                                                        .assigneeId
                                                    ]
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      {
                                        staticClass: "body-2 mb-1 name-n-avatar"
                                      },
                                      [
                                        _c("UserName", {
                                          attrs: {
                                            user:
                                              _vm.$store.state.org.employees[
                                                item.assocContent.assigneeId
                                              ]
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-subtitle",
                                      { staticClass: "caption mt-1" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.getJobInfo(item)) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.deptIds",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "text-capitalize type" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.getDepartment(item)) +
                              "\n        "
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.inferredType",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "text-capitalize type" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.inferredType) +
                              "\n        "
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.assocContentState",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm.isApproved(item)
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "not-clickable",
                                                  attrs: {
                                                    color: "success",
                                                    size: "16"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n              fas fa-check-circle\n            "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c("span", { staticClass: "body-2" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("labels.approved")) +
                                      "\n          "
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.isRejected(item)
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "not-clickable",
                                                  attrs: {
                                                    color: "error",
                                                    size: "16"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n              fas fa-times-circle\n            "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c("span", { staticClass: "body-2" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("labels.rejected")) +
                                      "\n          "
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.isWithDrawn(item)
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "not-clickable",
                                                  attrs: {
                                                    color: "darken-1 grey",
                                                    size: "16"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n              fas fa-trash-undo-alt\n            "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c("span", { staticClass: "body-2" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("labels.withdrawn")) +
                                      "\n          "
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.isExpired(item)
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "not-clickable",
                                                  attrs: {
                                                    color: "darken-1 grey",
                                                    size: "16"
                                                  }
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n              fas fa-clock\n            "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c("span", { staticClass: "body-2" }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("labels.expired")) +
                                      "\n          "
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.createdOn",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.formatDateTime(item.createdOn)) +
                            "\n      "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.notificationReceipts",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._l(_vm.notificationReceiptUsers(item), function(
                          userId
                        ) {
                          return [
                            _vm.receiptIsReadByUser(item, userId)
                              ? _c(
                                  "v-tooltip",
                                  {
                                    key: "tooltip-" + userId,
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass:
                                                        "info--text ml-1 not-clickable text--lighten-1",
                                                      attrs: { size: "16" }
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                fas fa-user-check\n              "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _c("div", { staticClass: "body-2" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$store.state.org.employees[
                                              userId
                                            ].fullName
                                          ) +
                                          "\n            "
                                      )
                                    ]),
                                    _c("div", { staticClass: "caption" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.formatDateTime(
                                              item.notificationReceipts[userId]
                                                .lastReadOn
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ])
                                  ]
                                )
                              : _c(
                                  "v-icon",
                                  {
                                    key: "tooltip-check-" + userId,
                                    staticClass:
                                      "grey--text ml-1 not-clickable text--lighten-2",
                                    attrs: { size: "16" }
                                  },
                                  [
                                    _vm._v(
                                      "\n            fas fa-user-check\n          "
                                    )
                                  ]
                                )
                          ]
                        })
                      ]
                    }
                  },
                  {
                    key: "item.modifiedBy",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$store.state.org.employees[item.modifiedBy]
                                  .fullName
                              ) +
                              "\n        "
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.modifiedOn",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.formatDateTime(item.modifiedOn)) +
                            "\n      "
                        )
                      ]
                    }
                  },
                  {
                    key: "no-data",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "body-2 grey--text mt-5 no-results text--darken-3 text-left"
                          },
                          [
                            _c("div", { staticClass: "my-2 subtitle-2" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("descriptions.noResultsFound")
                                  ) +
                                  "\n          "
                              )
                            ]),
                            _c("v-divider"),
                            _c("div", { staticClass: "mb-2 mt-4" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("descriptions.emptyGridHelpTitle")
                                  ) +
                                  "\n          "
                              )
                            ]),
                            _c("div", { staticClass: "my-2" }, [
                              _c("ul", [
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "descriptions.emptyGridHelpRemoveFilters"
                                      )
                                    )
                                  )
                                ]),
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "descriptions.emptyGridHelpShorterWords"
                                      )
                                    )
                                  )
                                ]),
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "descriptions.emptyGridHelpSpelling"
                                      )
                                    )
                                  )
                                ])
                              ])
                            ])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "item.data-table-expand",
                    fn: function(ref) {
                      var expand = ref.expand
                      var isExpanded = ref.isExpanded
                      var item = ref.item
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "request-expand",
                            style: {
                              visibility:
                                _vm.isEventRequest(item) ||
                                _vm.isRescheduleRequest(item)
                                  ? "hidden"
                                  : "visible"
                            },
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return expand(!isExpanded)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    isExpanded
                                      ? "fas fa-chevron-up"
                                      : "fas fa-chevron-down"
                                  ) +
                                  "\n          "
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "expanded-item",
                    fn: function(ref) {
                      var innerHeaders = ref.headers
                      var item = ref.item
                      return [
                        _c(
                          "td",
                          { attrs: { colspan: innerHeaders.length } },
                          [
                            _vm.isSwapRequest(item)
                              ? _c("SwapRequestSummary", {
                                  staticClass: "pl-11",
                                  attrs: { request: item }
                                })
                              : _vm.isSplitRequest(item)
                              ? _c("SplitRequestSummary", {
                                  staticClass: "pl-11",
                                  attrs: { request: item }
                                })
                              : _vm.isGiveawayRequest(item)
                              ? _c("GiveawayRequestSummary", {
                                  staticClass: "pl-11",
                                  attrs: { request: item }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "footer",
                    fn: function() {
                      return [
                        _vm.$vuetify.breakpoint.smAndDown
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mobile pa-1 pagination text-center"
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.retrievingHistoryRequests ||
                                          _vm.historyRequestsCurrentPage === 1,
                                        icon: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.paginateHistoryRequests(-1)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v(
                                          "\n                far fa-chevron-left\n              "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("span", { staticClass: "body-2 mx-1" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.historyRequestsCurrentPage) +
                                        "\n            "
                                    )
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "body-2 grey--text text--darken-2"
                                    },
                                    [_vm._v("/")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "body-2 mx-1 grey--text text--darken-2"
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$store.state.request
                                              .historyRequests.pages
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.retrievingHistoryRequests ||
                                          _vm.historyRequestsCurrentPage ===
                                            _vm.$store.state.request
                                              .historyRequests.pages,
                                        icon: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.paginateHistoryRequests(1)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v(
                                          "\n                far fa-chevron-right\n              "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          : _c("v-pagination", {
                              staticClass: "ma-1",
                              attrs: {
                                color: "secondary",
                                disabled: _vm.retrievingHistoryRequests,
                                length:
                                  _vm.$store.state.request.historyRequests
                                    .pages,
                                "next-icon": "far fa-chevron-right",
                                "prev-icon": "far fa-chevron-left",
                                "total-visible": _vm.maxPaginationControls
                              },
                              model: {
                                value: _vm.historyRequestsCurrentPage,
                                callback: function($$v) {
                                  _vm.historyRequestsCurrentPage = $$v
                                },
                                expression: "historyRequestsCurrentPage"
                              }
                            })
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.selectedRows,
                  callback: function($$v) {
                    _vm.selectedRows = $$v
                  },
                  expression: "selectedRows"
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }